import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const RefreshPopup = ({ onRefresh, visible }) => {
    return (
        <Dialog
            header="🚀 New Update Available"
            visible={visible}
            onHide={() => {}}
            footer={null}
            closable={false}
            draggable={false}
            resizable={false}
            position="center"
        >
            <p>New features are available! Click below to refresh and apply the latest updates.</p>

            <Button 
                label="Refresh"
                icon="pi pi-refresh"
                onClick={onRefresh}
                className="p-button-secondary mt-2"
            />
        </Dialog>
    );
};

export default RefreshPopup;
